import * as React from 'react';
import { Dispatch } from 'redux';
import { EventTransitionViewModel } from 'stageclip-common';

import { BaseApiPutRequest } from '../generic/baseApiPutRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventTransitionNormalizers from '../normalizers/eventTransitionNormalizers';

export class AddEventTransitionRequest extends BaseApiPutRequest<
  EventTransitionViewModel,
  EntityNormalizers.NormalizedSingleEntity<EventTransitionNormalizers.NormalizedEventTransitions>
> {
  constructor(eventId: string, eventTransition: any, component: React.Component, dispatch: Dispatch) {
    super({ transition: eventTransition }, component, dispatch);
    this.path = `/events/${eventId}/transitions`;
    this.normalizeMethod = EventTransitionNormalizers.normalizeEventTransition;
  }
}
